import React, { useCallback, useState } from "react"
import { CustomIconButton, PrimaryButton, TertiaryButton } from "shared/buttons"
import { useModal } from "hooks"
import {
  redirectTo,
  ACTIVITY_HUB_SUBMITTER_IMPORTS_PATH,
  ACTIVITY_HUB_AH_USER_IMPORTS_PATH,
  ADMIN_USERS_PATH,
} from "utils/routeHelpers"
import { Select } from "shared/selects"
import Modal, { ModalHeader } from "shared/Modal"
import withReduxProvider from "shared/withReduxProvider"

const USER_IMPORT_PATHS = {
  Submitters: ACTIVITY_HUB_SUBMITTER_IMPORTS_PATH,
  "Activity Hub Users": ACTIVITY_HUB_AH_USER_IMPORTS_PATH,
}

const IMPORT_TYPE_OPTIONS = [
  { label: "Submitters", value: "Submitters" },
  { label: "Activity Hub Users", value: "Activity Hub Users" },
]

const ImportUsersModal = () => {
  const { modalIsOpen, openModal, closeModal } = useModal()
  const [importType, setImportType] = useState("")

  const close = useCallback(() => {
    closeModal()
    setImportType("")
  }, [closeModal, setImportType])

  const goToImportUsers = () => {
    const path = USER_IMPORT_PATHS[importType] || ADMIN_USERS_PATH

    redirectTo(path)
  }

  return (
    <>
      <div className="flex justify-center">
        <CustomIconButton
          text="Import From CSV"
          className="tertiary-button"
          icon="import-csv"
          onClick={openModal}
        />
      </div>

      <Modal
        isOpen={modalIsOpen}
        aria={{ label: "import users" }}
      >
        <ModalHeader closeModal={close} heading="Select Type of Users to Import" />
        <div className="w-3/4 mx-auto">
          <Select
            className="bordered-base-input text-sm mb-4"
            backspaceDelete={false}
            name="import-type-select"
            isFullWidth
            onChange={setImportType}
            options={IMPORT_TYPE_OPTIONS}
            value={importType}
            label="select import user type"
            placeholder="Select user type for import ..."
          />
          <div className="flex justify-center mt-8 mb-10">
            <TertiaryButton
              text="Cancel"
              onClick={close}
              className="border border-light-300 mr-2"
            />
            <PrimaryButton
              text="Submit"
              type="submit"
              disabled={!importType}
              onClick={goToImportUsers}
            />
          </div>
        </div>
      </Modal>
    </>
  )
}

export default withReduxProvider(ImportUsersModal)
